// px2rem 工具函数
// 设计稿基准宽度
const DESIGN_WIDTH = 3840;
// 基准值 (设计稿宽度 / 100)
const BASE = DESIGN_WIDTH / 100;

/**
 * 将px转换为rem
 * @param {number} px - 像素值
 * @returns {string} - 转换后的rem值
 */
export function px2rem(px, base = BASE) {
  return `${(px / base) * 1}rem`;
}

/**
 * 将px转换为rem（返回数值）
 * @param {number} px - 像素值
 * @returns {number} - 转换后的rem数值
 */
export function px2remValue(px) {
  return (px / BASE) * 1;
}

/**
 * 动态计算当前屏幕下的px值
 * @param {number} px - 设计稿中的像素值
 * @returns {number} - 当前屏幕下的实际像素值
 */
export function getCurrentPx(px) {
  const currentWidth = window.innerWidth;
  return (px / DESIGN_WIDTH) * currentWidth;
}

/**
 * 获取当前屏幕的缩放比例
 * @returns {number} - 缩放比例
 */
export function getScaleRatio() {
  return window.innerWidth / DESIGN_WIDTH;
}

/**
 * 批量转换px到rem
 * @param {Object} styles - 包含px值的样式对象
 * @returns {Object} - 转换后的样式对象
 */
export function convertStylesToRem(styles) {
  const convertedStyles = {};
  
  for (const [key, value] of Object.entries(styles)) {
    if (typeof value === 'number' && value > 0) {
      // 假设数值类型的属性需要转换
      convertedStyles[key] = px2rem(value);
    } else if (typeof value === 'string' && /^\d+px$/.test(value)) {
      // 处理 "20px" 格式的字符串
      const pxValue = parseInt(value);
      convertedStyles[key] = px2rem(pxValue);
    } else {
      convertedStyles[key] = value;
    }
  }
  
  return convertedStyles;
}

export default {
  px2rem,
  px2remValue,
  getCurrentPx,
  getScaleRatio,
  convertStylesToRem
};
